import { getRequest, initialize } from '@icimscorp/spafx';
import React from 'react';
import { useLocation, useNavigate } from 'react-router';

import { FeedbackCenterLayout } from './FeedbackCenter/FeedbackCenterLayout';
import { FormBuilderLayout } from './FormBuilder/FormBuilderLayout';

let navigate = null;

/* istanbul ignore next */
const routeChangeHandler = (route) => {
	if (navigate === null || typeof navigate === 'undefined') {
		return;
	}

	navigate(route);
};

initialize({
	name: 'feedback-spa',
	enableLogging: true,
	routeChangeHandler,
});

export function Layout() {
	const { pathname } = useLocation();
	navigate = useNavigate();
	// Need to call spafx getRequest here so spafx sends
	// FRAME_READY message instead of FRAME_TIMEOUT message to parent spa
	getRequest();

	return pathname.includes('/settings') ? <FormBuilderLayout /> : <FeedbackCenterLayout />;
}

export default Layout;
